import React from 'react';
import { format } from 'date-fns';
import { Clock, User } from 'lucide-react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../../ui/hover-card';
import { eventRange, parseTime, fmtMinutes } from './calendarUtils';

const fmtKey = (k) => format(new Date(`${k}T00:00:00`), 'MMM d');

export const eventTimeLabel = (e) => {
  const r = eventRange(e);
  if (!r) return '';
  const dates = r[0] === r[1] ? fmtKey(r[0]) : `${fmtKey(r[0])} – ${fmtKey(r[1])}`;
  const st = parseTime(e.startTime);
  const et = parseTime(e.endTime);
  if (st == null) return `${dates} · All day`;
  return `${dates} · ${fmtMinutes(st)}${et != null ? ` – ${fmtMinutes(et)}` : ''}`;
};

export const EventHoverCard = ({ event, children }) => (
  <HoverCard openDelay={200} closeDelay={50}>
    <HoverCardTrigger asChild>{children}</HoverCardTrigger>
    <HoverCardContent className="w-72 p-3" side="top" data-testid={`calendar-hovercard-${event.id}`}>
      <div className="flex items-start gap-2">
        <span className="mt-1 w-2.5 h-2.5 rounded-full shrink-0" style={{ background: event.color }} />
        <p className="text-sm font-semibold leading-snug" data-testid="hovercard-title">{event.title}</p>
      </div>
      <div className="mt-2.5 space-y-1.5 text-xs text-muted-foreground">
        <div className="flex items-start gap-2" data-testid="hovercard-trainer">
          <User className="w-3.5 h-3.5 mt-px shrink-0" />
          <span>{event.trainers?.length ? event.trainers.join(', ') : 'No trainer assigned'}</span>
        </div>
        <div className="flex items-start gap-2" data-testid="hovercard-time">
          <Clock className="w-3.5 h-3.5 mt-px shrink-0" />
          <span>{eventTimeLabel(event)}</span>
        </div>
      </div>
      {event.statusLabel && (
        <span
          className="inline-block mt-2.5 text-[11px] font-medium px-2 py-0.5 rounded-full"
          style={{ background: `${event.color}1F`, color: event.color }}
          data-testid="hovercard-status"
        >
          {event.statusLabel}
        </span>
      )}
    </HoverCardContent>
  </HoverCard>
);
